module.exports = __webpack_public_path__ + "img/main_Avitseron.5cb4a4a1.jpeg";